<template>
  <modal :show="show" @close="close">
    <v-flex class="ma-1" slot="title">Dodaj wniosek o nową kartę</v-flex>

    <v-layout column>
      <v-flex>
        <template v-for="(group, index) in groups">
          <w-schema :key="'group_' + index" :model="$schema.application.groups">
            <v-checkbox v-model="$schema.application.groups.$value" :label="group.admin" :value="group" />
          </w-schema>
        </template>
      </v-flex>

      <v-flex>
        <w-schema :model="$schema.application.date">
          <v-text-field label="Data złożenia wniosku (w formacie DD.MM.YYYY) *" />
        </w-schema>
      </v-flex>

      <v-flex>
        <w-schema :model="$schema.application.virtual">
          <v-checkbox disabled :label="$schema.application.virtual.$schema.title" />
        </w-schema>
      </v-flex>

      <v-flex>
        <w-schema :model="$schema.application.physical">
          <v-checkbox :label="$schema.application.physical.$schema.title" />
        </w-schema>
      </v-flex>

      <v-flex v-if="!$schema.application.collectionPointId.$schema.disabled">
        <w-schema :model="$schema.application.collectionPointId">
          <v-select label="Punkt odbioru" item-text="text" item-value="value" :items="collectionPoints" />
        </w-schema>
      </v-flex>
    </v-layout>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { ApplicationType, formatError } from '@witkac/kartamiejska-shared';
import { schemaMixin, WSchema } from '@witkac/vuetify-components';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';

import Modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/application.schema';

function emptyData() {
  return {
    application: undefined
  };
}

// @vuese
// Modal dodawnia wniosku klienta
// @group Client-Profile
export default {
  schema,
  mixins: [manageMixin('application', {}, emptyData), notificationsMixin],
  components: { WSchema, Modal },
  methods: {
    // @vuese
    // Ustawia dane formularza
    setData() {
      this.$schema.application.$setData({ ...this.profile });
      this.$schema.application.type.$setData(ApplicationType[ApplicationType.NEW]);
    },
    // @vuese
    // Zapisuje wniosek
    save() {
      if (!this.$schema.$validateAll().length) {
        const model = this.$schema.$getData();

        this.$store
          .dispatch('application/add', { ...model })
          .then(() => {
            this.notifySuccess('Dodano wniosek');
            this.$store.dispatch('application/list', { profileId: this.profile.id, withInactive: true });
            this.closeModal();
          })
          .catch(error => this.notifyError(formatError(error)));
      } else {
        this.notifyError('Błędnie wypełniony formularz.');
      }
    }
  },
  computed: {
    ...mapState({
      profile: state => ({ ...state.client.data.profile, profileId: state.client.data.profile.id }),
      collectionPoints: state =>
        state.collectionPoint.list.map(collectionPoint => ({
          value: collectionPoint.id + '',
          text: collectionPoint.name
        })),
      groups: state =>
        state.settings.settings &&
        state.settings.settings.APPLICATION_GROUPS_FORM &&
        JSON.parse(state.settings.settings.APPLICATION_GROUPS_FORM.value)
    })
  },
  mounted() {
    this.$store.dispatch('collectionPoint/list');
    this.$store.dispatch('settings/settingFind', 'APPLICATION_GROUPS_FORM');
  }
};
</script>
